import { PricingSheetRow } from '../../../../../../shared/types';

const updateRows = (newRows: PricingSheetRow[]) => {
  return newRows;
};

export default updateRows;
